import logoSrc from '../assets/images/logo-nissan-white.png';
import bgImageSrc from '../assets/images/Origami/bg-full.png';
import canvasToImage from 'canvas-to-image';
import { view } from '@risingstack/react-easy-state';
import I18n from './I18n';
import { useLocation } from 'react-router-dom';
import { useLocale } from '../Locale';
import canvasTxt from 'canvas-txt';
import { Button } from './Link';

const OrigamiDownloader = (props) => {
  const locale = useLocale();
  const location = useLocation();
  
  async function createCanvas(download = true) {
    //init canvas
    const canvas = document.querySelector('#origami-canvas');
    const context = canvas.getContext('2d');
    //set canvas size
    canvas.width = 1280;
    canvas.height = 720;
    //clear
    context.clearRect(0, 0, canvas.width, canvas.height);
    //add bg color
    context.fillStyle = '#000';
    context.fillRect(0, 0, 1280, 720);
    //add bg
    const bgImage = new Image();
    const logo = new Image();
    const image = new Image();

    const imagesLoad = Promise.all([
      new Promise((f) => (bgImage.onload = f)),
      new Promise((f) => (image.onload = f)),
      new Promise((f) => (logo.onload = f)),
    ]);

    bgImage.src = bgImageSrc;
    logo.src = logoSrc;
    image.src = props.foldedImage;

    await imagesLoad;

    context.drawImage(bgImage, 0, 0, 1280, 720);
    //add nissan logo

    logo.src = logoSrc;
    logo.width = 100;
    logo.height = 84;
    context.drawImage(logo, 40, 80);

    image.width = 450;
    image.height = 450;
    context.drawImage(image, canvas.width / 2 - image.width / 2, 30, 450, 450);
    //add text
    //loop lines
    let fontFamily = `NissanFont`;
    if (locale === 'jp') {
      fontFamily = `'ShinGoPro-Regular'`;
    }
    
    //add user message
    const text = I18n.getTranslation(locale, props.selectedMessage.text);
    const posY = 450;
    context.fillStyle="#fff"
    canvasTxt.fontSize = 24
    canvasTxt.font = fontFamily
    canvasTxt.lineHeight = 28
    const textWidth = 700
    canvasTxt.drawText(context, text, (canvas.width / 2) - (textWidth/2), posY, textWidth, 100)

    //add client message
    const disclaimer = I18n.getTranslation(locale, props.selectedMessage.disclaimer);
    const disclaimerPosY = 600;
    context.fillStyle="#fff"
    canvasTxt.fontSize = 16
    canvasTxt.font = fontFamily
    canvasTxt.lineHeight = 18
    canvasTxt.drawText(context, disclaimer, (canvas.width / 2) - (textWidth/2), disclaimerPosY, textWidth, 100)
    
    //add line separator
    context.beginPath();
    context.rect(canvas.width / 2 - 75, 600, 150, 2);
    context.fill();

    if (download) {
      //init download
      canvasToImage(canvas, {
        name: 'origami',
        type: 'jpg',
        quality: 1,
      });
    } else {
      return canvas.toDataURL('image/png', {
        quality: 0.8,
      });
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    window.createCanvas = createCanvas;
  }

  return (
    <>
      <canvas id="origami-canvas"></canvas>
	  <Button className="btn-share download" onClick={createCanvas} text="download image" />
    </>
  );
};

export default view(OrigamiDownloader);
